module.exports = __webpack_public_path__ + "img/goodness-22.b77d9565.png";